import React from 'react';
import { connect } from 'react-redux';

import Rollover from './Rollover';
import PlayerLink from './PlayerLink';
import { Table, Td } from './Table';
import * as util from './util';

class ResultRolloverX extends React.Component {
    render() {
        const { data, club } = this.props;
        const result = data.result;
        const clubInnings = <ResultRolloverClubInnings result={result} batting={data.battingSummary} club={club} />;
        const oppoInnings = <ResultRolloverOppoInnings result={result} batting={data.oppoBattingSummary} bowling={data.bowlingSummary} />;
        let firstInnings = clubInnings;
        let secondInnings = oppoInnings;
        if (result.batted_first === 'No') {
            firstInnings = oppoInnings;
            secondInnings = clubInnings;
        }
        const resultClass = `cc-result-${result.result.toLowerCase().replace(' ', '_')}`;
        let details = result.details;
        if (result.result === 'Win' || result.result === 'Loss') {
            details = `${club.club} ${result.details.toLowerCase()}`;
        }
        return (
            <Rollover
                directionInfo={this.props.directionInfo}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
            >
                <div className="cc-panel-bar">
                    <div className="cc-panel-bar-content cc-text-center">
                        <h2>
                            {result.lname} v {result.opposition}
                        </h2>
                        <div>
                            {result.long_date} ({result.type})
                        </div>
                    </div>
                </div>
                {firstInnings}
                {secondInnings}
                <div className={`cc-panel-subbar cc-text-center ${resultClass}`}>{details}</div>
                <div className="cc-panel-buttons cc-text-center">
                    <a className="cc-flat-button" href={`/results/${this.props.mid}`}>
                        Full Scorecard
                    </a>
                </div>
            </Rollover>
        );
    }
}

const ResultRollover = connect(state => ({
    club: state.club
}))(ResultRolloverX);

export default ResultRollover;

const ResultRolloverClubInnings = ({ result, batting, club }) => (
    <div>
        <div className="cc-panel-subbar">
            <div className="cc-left">{club.club}</div>
            <div className="cc-right">{util.totalScore(result.runs, result.wickets)}</div>
            <div className="cc-clear" />
        </div>
        <div className="cc-cols-6">
            <Table compact>
                <tbody>
                    {batting.map((b, index) => (
                        <tr key={index}>
                            <Td left style={{ width: '35%' }}>
                                <PlayerLink pid={b.pid} fname={b.fname} lname={b.lname} runs={b.runs} norollover />
                            </Td>
                            <Td right className={`cc-runs-${b.isout.toLowerCase().replace(' ', '_')}`} style={{ width: '15%' }}>
                                {b.runs}
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    </div>
);

const ResultRolloverOppoInnings = ({ result, batting, bowling }) => (
    <div>
        <div className="cc-panel-subbar">
            <div className="cc-left">{result.opposition}</div>
            <div className="cc-right">{util.totalScore(result.oppo_runs, result.oppo_wickets)}</div>
            <div className="cc-clear" />
        </div>
        <div className="cc-cols-6">
            <Table compact>
                <tbody>
                    {batting.map((b, index) => (
                        <tr key={index}>
                            <Td left style={{ width: '35%' }}>
                                {b.name}
                            </Td>
                            <Td right className={`cc-runs-${b.isout.toLowerCase().replace(' ', '_')}`} style={{ width: '15%' }}>
                                {b.runs}
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
        <div className="cc-cols-6">
            <Table compact>
                <tbody>
                    {bowling.map((b, index) => (
                        <tr key={index}>
                            <Td left style={{ width: '35%' }}>
                                <PlayerLink pid={b.pid} fname={b.fname} lname={b.lname} wickets={b.wickets} norollover />
                            </Td>
                            <Td right style={{ width: '15%' }}>
                                {b.wickets}-{b.runs}
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ResultRollover.jsx